import React, { FC } from 'react';
import { TypeBlockImageFields } from '@/core/generated-types';

const BlockImage: FC<TypeBlockImageFields> = ({
  media,
  mobileMedia,
  width,
  height,
  mobileWidth,
  mobileHeight,
}) => {
  const hasMobileMedia = !!mobileMedia?.fields.Image?.fields?.file?.url;

  return (
    <>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={media?.fields.Image?.fields?.file?.url}
        alt={media?.fields.altText}
        width={width}
        height={height}
        className={hasMobileMedia ? 'hidden md:block' : 'block'}
      />
      {hasMobileMedia && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={mobileMedia?.fields.Image?.fields?.file?.url}
          alt={mobileMedia?.fields.altText}
          width={mobileWidth}
          height={mobileHeight}
          className="block md:hidden"
        />
      )}
    </>
  );
};

export default React.memo(BlockImage);
